import React, { useRef, useState } from "react";
// import { useIntl } from "react-intl";
// import { CustomButton } from "../../../lib/Buttons";
// import { RegularInput } from "../../../lib/Input";
// import UserTypeSelection from "./UserTypeSelection";
// import Header from "./Header";
// import SidePanel from "./SidePanel";
// import FooterLinks from "./FooterLinks";
// import RememberMeCheckbox from "./RememberMeCheckbox";
// import { useLocation } from "react-router-dom/";
// import LoginIcon from "../../../images/sign-in.svg?react";
// import Arrow from "../../../images/arrow.svg?react";
// import ReCAPTCHA from "react-google-recaptcha";

import SignIn from "~/images/log-in.svg?react";
import logo from "~/images/logos/watt-is.png";
import InputField from "~/lib/InputField";
import ReCAPTCHA from "react-google-recaptcha";
import Card from "../../../lib/Card";
import { OkCancelRow } from "../../../lib/Buttons";
import DeviseLayout from "./DeviseLayout";
import useCsrfToken from "~/hooks/useCsrfToken";
import useDeviseFeedback from "~/hooks/useDeviseFeedback";

// import {
//   incorrectCredentialsToast,
//   loginMissingFieldsToast,
//   maximumAttemptsToast,
//   unconfirmedAccountToast,
//   unexpectedErrorToast,
//   noRecaptchaToast,
// } from "../../../lib/Toasts";

// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./ToastStyles.css";

// const identifyParticularInvalidFields = (data) => {
//   const invalidFields = [];

//   const nif = data.nif?.trim() || "";
//   const password = data.password || "";

//   if (nif.length == 0) {
//     invalidFields.push("nif");
//   }

//   if (password.length == 0) {
//     invalidFields.push("password");
//   }

//   return invalidFields;
// };

// const identifyEmpresarialInvalidFields = (data) => {
//   const invalidFields = [];

//   const email = data.email?.trim() || "";
//   const password = data.password || "";

//   if (email.length == 0) {
//     invalidFields.push("email");
//   }

//   if (password.length == 0) {
//     invalidFields.push("password");
//   }

//   return invalidFields;
// };

const RegisterPage = () => {
  // const intl = useIntl();

  // const location = useLocation();

  // const query = new URLSearchParams(location.search);

  // const captchaRef = useRef(null);

  // const userType = query.get("type");

  // const [userData, setUserData] = useState({
  //   particular: {
  //     type: "particular",
  //     nif: "",
  //     password: "",
  //     remember_me: false,
  //   },
  //   empresarial: {
  //     type: "empresarial",
  //     email: "",
  //     password: "",
  //     remember_me: false,
  //   },
  // });

  // const [invalidFields, setInvalidFields] = useState([]);

  // const handleInputChange = (field, value) => {
  //   setUserData((prevData) => ({
  //     ...prevData,
  //     [userType]: {
  //       ...prevData[userType],
  //       [field]: value,
  //     },
  //   }));
  // };

  // const handleLogin = async () => {
  //   setInvalidFields([]);
  //   const csrfToken = document
  //     .querySelector("meta[name='csrf-token']")
  //     .getAttribute("content");

  //   const token = captchaRef.current.getValue();
  //   userData[userType].captcha_token = token;

  //   const loginData = userData[userType];

  //   const newInvalidFields =
  //     userType == "particular"
  //       ? identifyParticularInvalidFields(loginData)
  //       : identifyEmpresarialInvalidFields(loginData);

  //   if (newInvalidFields.length != 0) {
  //     setInvalidFields(newInvalidFields);

  //     toast.error(loginMissingFieldsToast, {
  //       className: "register-toast",
  //       progressClassName: "custom-progress-bar",
  //       icon: false,
  //     });

  //     return;
  //   }

  //   try {
  //     const response = await fetch("/users/sign_in", {
  //       method: "POST",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "X-CSRF-Token": csrfToken,
  //       },
  //       body: JSON.stringify(loginData),
  //     });

  //     if (!response.ok) {
  //       const data = await response.json();

  //       if (data.error.type == "locked-account") {
  //         toast.error(maximumAttemptsToast, {
  //           className: "register-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else if (data.error.type == "unconfirmed-account") {
  //         toast.error(unconfirmedAccountToast, {
  //           className: "register-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else if (data.error.type == "unauthorized") {
  //         toast.error(incorrectCredentialsToast, {
  //           className: "alert-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else if (data.error.type == "captcha_error") {
  //         toast.error(noRecaptchaToast, {
  //           className: "alert-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else {
  //         toast.error(unexpectedErrorToast, {
  //           className: "alert-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       }

  //       return;
  //     }

  //     window.location.href = "/consumptions";
  //   } catch (error) {
  //     toast.error(unexpectedErrorToast, {
  //       className: "alert-toast",
  //       progressClassName: "custom-progress-bar",
  //       icon: false,
  //     });
  //   } finally {
  //     captchaRef.current.reset();
  //   }
  // };

  useDeviseFeedback({ successMessage: "Registo realizado com sucesso! Verifique o seu e-mail para confirmar a conta." });

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [nif, setNif] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const captchaRef = useRef(null);
  const [captchaError, setCaptchaError] = useState(false);

  const [showTerms, setShowTerms] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const token = captchaRef.current?.getValue();

    if (!token) {
      setCaptchaError(true);
      return;
    }

    setCaptchaError(false);

    const form = e.target;

    let hiddenInput = form.querySelector("input[name='captcha_token']");
    if (!hiddenInput) {
      hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "captcha_token";
      form.appendChild(hiddenInput);
    }

    hiddenInput.value = token;

    form.submit();
  };

  const csrfToken = useCsrfToken();

  return (
    <>
      <DeviseLayout rightPanelClassName="flex flex-col justify-center p-4 lg:p-10 overflow-y-auto">
        <form
          action="/users"
          method="post"
          onSubmit={handleSubmit}
          className="flex flex-col lg:gap-2 gap-1"
        >
          <input
            type="hidden"
            value={csrfToken}
            name="authenticity_token"
          />

          <div className="flex flex-col items-center mb-2 lg:mb-3">
            <img
              src={logo}
              alt="Watt-IS"
              className="w-32 lg:w-52 h-auto mb-1 lg:mb-2"
            />
          </div>

          {/* <div className="flex flex-col mx-2 lg:mx-16">
              <InputField
                id="username"
                label="Nome de Utilizador"
                model={username}
                name="user[username]"
                onChange={setUsername}
                labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
                inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
              />
            </div> */}

          <div className="flex flex-col mx-2 lg:mx-16">
            <InputField
              id="email"
              label="E-mail"
              model={email}
              name="user[email]"
              onChange={setEmail}
              type="email"
              labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
              inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
            />
          </div>

          {/* <div className="grid grid-cols-2 gap-2 mx-2 lg:mx-16">
              <InputField
                id="nif"
                label="NIF"
                model={nif}
                name="user[nif]"
                onChange={setNif}
                labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
                inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
              />
              <InputField
                id="phone"
                label="Telemóvel"
                model={phone}
                name="user[phone]"
                onChange={setPhone}
                type="tel"
                labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
                inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
              />
            </div> */}

          <div className="flex flex-col mx-2 lg:mx-16">
            <InputField
              id="password"
              label="Palavra-passe"
              type="password"
              model={password}
              name="user[password]"
              onChange={setPassword}
              labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
              inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
              haveInfo={true}
              infoMsg="Palavra-passe: Incluir números, símbolos, letras maiúsculas e minúsculas. Usar no minimo 12 caracteres."
            />
          </div>

          <div className="flex flex-col mx-2 lg:mx-16">
            <InputField
              id="password_confirmation"
              label="Confirmação da palavra-passe"
              type="password"
              model={passwordConfirmation}
              name="user[password_confirmation]"
              onChange={setPasswordConfirmation}
              labelStyle="text-left text-[10px] lg:text-xs font-medium text-text-soft-gray"
              inputStyle="focus:ring-1 focus:ring-text-soft-gray px-3 py-1.5 lg:py-2 border border-gray-300 bg-gray-100 rounded-xl text-xs lg:text-sm"
            />
          </div>

          <hr className="h-[1px] bg-black border-0 my-2 mx-6" />

          <div className="flex flex-wrap items-center justify-between gap-y-2 mx-6 lg:mx-16 my-2">
            <button
              type="button"
              onClick={() => setShowTerms(true)}
              className="w-full sm:w-auto text-left text-xs font-semibold text-btn-tertiary hover:text-btn-primary"
            >
              Termos e Condições
            </button>

            <div className="flex items-center w-full sm:w-auto">
              <input
                type="checkbox"
                id="terms"
                required
                className="w-3 h-3 accent-btn-tertiary mr-1 flex-shrink-0"
              />

              <label
                htmlFor="terms"
                className="text-[10px] font-medium text-black whitespace-normal sm:whitespace-nowrap"
              >
                Li e aceito os termos e condições
              </label>
            </div>
          </div>

          <div className="flex flex-col items-center scale-75 lg:scale-100 -my-2">
            <div
              className={`rounded-lg p-1 transition-all duration-200 ${
                captchaError
                  ? "border-2 border-red-500 bg-red-50"
                  : "border-2 border-transparent"
              }`}
            >
              <ReCAPTCHA
                ref={captchaRef}
                sitekey={import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY}
                onChange={() => setCaptchaError(false)}
              />
            </div>

            {captchaError && (
              <p className="text-red-500 text-xs mt-2 text-center">
                Por favor valide o reCAPTCHA antes de registar.
              </p>
            )}
          </div>

          <button
            className="transition-all flex items-center justify-center gap-2 py-2 lg:py-3 rounded-full bg-btn-tertiary hover:bg-btn-primary text-sm lg:text-lg text-white font-semibold lg:mx-24 mx-4 mb-1 mt-3"
            type="submit"
          >
            Registar na plataforma
            <SignIn className="w-auto h-fit" />
          </button>

          <p className="text-center text-xs lg:text-base text-text-black font-medium mt-1">
            Já tem conta?{" "}
            <a
              href="/users/sign_in"
              className="text-btn-tertiary font-semibold"
            >
              Faça login aqui
            </a>
          </p>
        </form>
      </DeviseLayout>

      {showTerms && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 lg:p-10">
          <Card
            style="w-full lg:w-8/12 h-auto max-h-[90vh] flex flex-col overflow-hidden"
            title="Termos e Condições"
            headerClassName="bg-btn-primary flex-shrink-0"
          >
            <div className="flex flex-col overflow-y-auto p-4 lg:p-6 bg-white custom-scrollbar">
              <div className="text-justify font-semibold">
                <p className="text-sm text-gray-700 mb-4">
                  Ao aceder a este site, presumimos que aceita estes termos e
                  condições na totalidade. Não continue a utilizar o site da
                  (Nome da Loja) se não aceitar todos os termos e serviços
                  referidos nesta página.
                </p>

                <p className="text-sm text-gray-700 mb-4">
                  A terminologia seguinte aplica-se a estes Termos e Condições,
                  Declaração de Privacidade e Aviso de Isenção de
                  Responsabilidade, assim como a todo e qualquer Acordo:
                  Cliente, Você e Seu referem-se a Si, a pessoa que está a
                  aceder a este Site para aceitar os termos e condições da
                  Empresa. A Empresa, Nós e Nosso referem-se à nossa Empresa.
                  Entidade, Entidades, ou Nós, referem-se tanto ao Cliente como
                  a nós, ou só ao Cliente ou só a nós.
                </p>

                <p className="text-sm text-gray-700 mb-4">
                  Todos os termos referem-se à oferta, aceitação e consideração
                  do pagamento necessário para levar a cabo o processo da nossa
                  assistência ao Cliente da forma mais apropriada, seja através
                  de reuniões formais de duração fixa, ou qualquer outro meio,
                  com o objetivo expresso de cumprir as necessidades do Cliente
                  no que diz respeito ao fornecimento dos serviços/produtos da
                  Empresa, de acordo com, e sujeito à lei vigente de (Endereço).
                </p>

                <p className="text-sm text-gray-700 mb-4">
                  Qualquer uso da terminologia acima ou outras palavras no
                  singular, plural, em maiúscula/minúscula e/ou ele/ela ou
                  eles/elas são tomados como intermutáveis e, portanto,
                  referem-se ao mesmo.
                </p>

                <h3 className="text-base mb-2">Cookies</h3>

                <p className="text-sm text-gray-700 mb-4">
                  Utilizamos cookies. Ao usar o site da (Nome da Loja) consente
                  a utilização de cookies de acordo com a política de
                  privacidade da (Nome da Loja). A maioria dos sites interativos
                  de hoje em dia usam cookies que nos permitem recuperar os
                  detalhes do utilizador para cada visita.
                </p>

                <p className="text-sm text-gray-700 mb-2">
                  As cookies são usadas em algumas áreas do nosso site para
                  permitir a funcionalidade desta área e facilitar a utilização
                  dos visitantes. Alguns dos nossos afiliados e parceiros
                  publicitários podem também usar cookies.
                </p>
              </div>

              <OkCancelRow
                className="mt-6 flex justify-center gap-3 pb-2"
                cancelLabel="Cancelar"
                okLabel="Guardar"
                onCancel={() => setShowTerms(false)}
                onOk={() => {
                  const termsCheckbox = document.getElementById("terms");
                  if (termsCheckbox) termsCheckbox.checked = true;
                  setShowTerms(false);
                }}
              />
            </div>
          </Card>
        </div>
      )}
    </>
  );
};

export default RegisterPage;
